export const SVG_WIDTH = 500;
export const SVG_HEIGHT = 100;
